import { Component, OnInit } from '@angular/core';
import { IDocument } from '../interfaces/idocument';
import { Observable } from 'rxjs';
import { FileUploadService } from '../services/file-upload.service';
import { tap } from 'rxjs/operators';


import { saveAs } from 'file-saver';
 declare var require: any;
 const FileSaver = require('file-saver');

@Component({
  selector: 'app-taxpayer-document',
  templateUrl: './taxpayer-document.component.html',
  styleUrls: ['./taxpayer-document.component.scss']
})
export class TaxpayerDocumentComponent implements OnInit {

  
  public tin : string;
  public document : Array<IDocument>;
  public taxpayerDocument$: Observable<boolean>;
  public pdf:any;
  public base_url = "https://eservices.lra.gov.lr/tccApp/assets/doc/";
  //public base_url = "http://10.0.16.73:8093/tccApp/assets/doc/";
  public pdfsrc= "";
  
  constructor(private fileService:FileUploadService) { }

  ngOnInit() {
    this.tin = localStorage.getItem("tin");
    this.taxpayerDocument$ = this.fileService.getTaxpayerDocument(this.tin).pipe(tap(r => {
      this.document = this.fileService.taxpayerDocument;
  }))
  }

  downloadPdf(pdfUrl: string, pdfName: string ) {
    FileSaver.saveAs(pdfUrl, pdfName);
  }
  openDoc(pdfUrl: string) {
    //window.open(pdfUrl, '_blank');
    this.fileService.postFilename(pdfUrl).subscribe(
      data=>this.pdf=data
    )
  }

  changeSrc(src){
    let path = src.substring(82)
    this.pdfsrc = this.base_url+path;
    console.log(this.pdfsrc);
  }

}
